import _ from 'lodash'
const END_TIME = 'live'
const WINDOW_SIZE = 0

class GraphSubscriber {
  constructor(opts) {
    this.workerToUiGraphBus = opts.workerToUiGraphBus
    this.uiToWorkerGraphBus = opts.uiToWorkerGraphBus
    this.worker = opts.worker
    this.sensorStore = opts.sensorStore
    // this.agentOverview = this.sensorStore.agentOverview
    this.timeWindow = {
      endTime: END_TIME,
      windowSize: WINDOW_SIZE
    }
    this.initBusses()
  }

  initBusses() {
    this.uiToWorkerGraphBus.onValue((val) => {
      return this.worker.postMessage({
        eventType: 'graph_data',
        message: val
      })
    })
  }

  normalizeGroupDataOptions (dataOptions) {
    if (dataOptions.agentIds) {
      var sortedSensors = _.sortBy(dataOptions.agentIds)
      if (!(_.isEqual(sortedSensors, _.sortBy(this.sensorStore.getActiveSensorIds())) ||
            _.isEqual(sortedSensors, _.sortBy(this.sensorStore.getSensorIds())))) {
        dataOptions.sensorId = dataOptions.agentIds[0]
      } else {
        dataOptions.sensorId = null
      }
      delete dataOptions.agentIds
    }
  }

  createGroup(groupName, dataOptions = {}) {
    if (!dataOptions.endTime || dataOptions.endTime == null) {
      dataOptions.endTime = this.timeWindow.endTime
    }
    if (!dataOptions.windowSize || dataOptions.windowSize == null) {
      dataOptions.windowSize = this.timeWindow.windowSize
    }
    this.normalizeGroupDataOptions(dataOptions)
    return this.uiToWorkerGraphBus.push({
      groupName: groupName,
      type: 'createGroup',
      dataOptions: dataOptions
    })
  }

  changeGroupOptions(groupName, dataOptions) {
    this.normalizeGroupDataOptions(dataOptions)
    return this.uiToWorkerGraphBus.push({
      groupName: groupName,
      type: 'groupOptions',
      dataOptions: dataOptions
    })
  }

  destroyGroup(groupName) {
    return this.uiToWorkerGraphBus.push({
      groupName: groupName,
      type: 'destroyGroup'
    })
  }

  subscribe(graphOptions, graphId, groupName) {
    graphId = graphId || graphOptions.graphId
    const message = {
      graphId: graphId,
      groupName: groupName,
      type: 'subscribe',
      viewOptions: graphOptions.viewOptions,
      dataOptions: graphOptions.dataOptions
    }
    this.uiToWorkerGraphBus.push(message)
    return this.workerToUiGraphBus
      .filter(_msg => {
        return _msg.graphId === graphId && _msg.type === 'dataUpdate'
      })
      .map(_msg => _msg.graphData)
  }

  getDataLoadedStream(graphId) {
    return this.workerToUiGraphBus
      .filter(_msg => _msg.graphId === graphId && _msg.type === 'dataLoaded')
      .map(_msg => _msg.graphData)
  }

  unsubscribe(graphId) {
    return this.uiToWorkerGraphBus.push({
      graphId: graphId,
      type: 'unsubscribe'
    })
  }

  requestUpdate(graphId) {
    return this.uiToWorkerGraphBus.push({
      graphId: graphId,
      type: 'dataRequest'
    })
  }

  changeGraphViewOptions(graphId, partialViewOptions) {
    return this.uiToWorkerGraphBus.push({
      graphId: graphId,
      type: 'graphViewOptions',
      viewOptions: partialViewOptions
    })
  }

  changeGraphDataOptions(graphId, dataOptions) {
    return this.uiToWorkerGraphBus.push({
      graphId: graphId,
      type: 'graphDataOptions',
      dataOptions: dataOptions
    })
  }
}

export default GraphSubscriber
